module.exports = __webpack_public_path__ + "img/punch-card-qr-container-bg.c8555cfc.png";